export default function isOwnProfile(): boolean {
  return window.location.href.includes("/profile");
}
